var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.981 22.361a6.62 6.62 0 0 1-6.62 6.62H9.639a6.62 6.62 0 0 1-6.62-6.62V9.638a6.62 6.62 0 0 1 6.62-6.62h12.722a6.62 6.62 0 0 1 6.62 6.62v12.723zM32 9.638C32 4.315 27.684 0 22.36 0H9.64C4.315 0 0 4.315 0 9.638v12.723C0 27.684 4.316 32 9.64 32h12.72A9.64 9.64 0 0 0 32 22.36V9.638zm-15.946 11.63a5.068 5.068 0 0 1-5.062-5.062 5.068 5.068 0 0 1 5.062-5.062 5.067 5.067 0 0 1 5.062 5.062 5.067 5.067 0 0 1-5.062 5.062zm0-12.964c-4.357 0-7.902 3.545-7.902 7.902 0 4.358 3.545 7.902 7.902 7.902 4.358 0 7.903-3.544 7.903-7.902 0-4.357-3.545-7.902-7.903-7.902zm8.364-2.413a1.881 1.881 0 1 0 0 3.763 1.881 1.881 0 0 0 0-3.763z",
    fill: "#512211"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.88cd8e632797e93eb7e643aa2acc831a.svg";
export { ForwardRef as ReactComponent };